module.exports = __webpack_public_path__ + "static/media/IconSearch.d37ddeb8.svg";